import { WeaTools } from 'ecCom'

export const getHasRight = params => {
  return WeaTools.callApi('/api/hrm/report/rpsubsearch/hasRight', 'GET', params);
}

export const getSearchCondition = params => {
  return WeaTools.callApi('/api/hrm/report/rpsubsearch/getSearchCondition', 'GET', params);
}

export const getSearchList = params => {
  return WeaTools.callApi('/api/hrm/report/rpsubsearch/getSearchList', 'POST', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/rpsubsearch.js